import { render, staticRenderFns } from "./NPAssetDetail.vue?vue&type=template&id=9b9e1530&scoped=true&"
import script from "./NPAssetDetail.vue?vue&type=script&lang=js&"
export * from "./NPAssetDetail.vue?vue&type=script&lang=js&"
import style0 from "./NPAssetDetail.vue?vue&type=style&index=0&id=9b9e1530&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b9e1530",
  null
  
)

export default component.exports